<template>
  <!--主界面公共头-->
  <div class="header_div">
    <el-row :gutter="0">
      <el-col :span="12">
        <img src="../assets/logo.jpg" width="371" height="auto" style="cursor: pointer" @click="to_home"/>
        <img src="../assets/logo_sub.jpg" width="185" height="auto" style="cursor: pointer" @click="to_home"/>
      </el-col>
      <el-col :span="12">
        <el-menu
          :default-active="default_index"
          text-color="#333333"
          active-text-color="#E71489"
          class="el-menu-demo menu-div"
          mode="horizontal"
          @select="handleSelect">
          <el-menu-item index="1">最新动态</el-menu-item>
          <el-menu-item index="2">教研学术</el-menu-item>
          <!-- <el-menu-item index="3">课程产品</el-menu-item> -->
          <el-submenu index="2-4">
            <template slot="title">课程产品</template>
            <el-menu-item index="44">人工智能系列</el-menu-item>
            <el-menu-item index="22">电子编程系列</el-menu-item>
            <!-- <el-menu-item index="33">物联系列</el-menu-item> -->
            <el-menu-item index="11">结构电子系列</el-menu-item>
            <el-menu-item index="55">教学展示系列</el-menu-item>
          </el-submenu>
          <el-menu-item index="4">解决方案</el-menu-item>
          <el-menu-item index="5">赛事中心</el-menu-item>
        </el-menu>
      </el-col>
      <!-- <el-col :span="1">
        <div class="right-icon-div">
          <i class="el-icon-s-home"></i>
          <i class="el-icon-chat-dot-round"></i>
          <i class="el-icon-search"></i>
        </div>
      </el-col> -->
    </el-row>

  </div>
</template>

<script>
export default {
  name: 'about_header',
  props:{
    default_index: {    //默认选中的下标
      type:String,
      require: false,
      default:''
    }
  },
  methods: {
    to_home () {
      this.activeIndex = ''
      this.$router.push({path: '/'})
    },
    handleSelect (key, keyPath) {
      if (key == '1') {  //最新动态
        this.$router.push({path: '/news'})
      } else if (key == '2') {   //教研学术
        this.$router.push({path: '/science'})
      } else if (key == '3') {   //课程方案
        this.$router.push({path: '/course', query: {type:"结构电子系列",type_num:1}})
      } else if (key == '4') {   //解决方案
        this.$router.push({path: '/solution'})
      } else if (key == '5') {   //赛事中心
        this.$router.push({path: '/match'})
      }
      else if (key == '11') {  //结构电子系列
        this.$router.push({path: '/course', query: {type:"结构电子系列",type_num:1}})
      } else if (key == '22') {   //电子编程系列
        this.$router.push({path: '/course', query: {type:"电子编程系列",type_num:2}})
      } else if (key == '33') {   //物联系列
        this.$router.push({path: '/course', query: {type:"物联系列",type_num:3}})
      } else if (key == '44') {   //人工智能系列
        this.$router.push({path: '/course', query: {type:"人工智能系列",type_num:4}})
      } else if (key == '55') {   //教学展示系列
        this.$router.push({path: '/course', query: {type:"教学展示系列",type_num:5}})
      }
    }
  }
}
</script>

<style scoped lang="scss">

/deep/ .el-menu-item {
  font-size: 12pt;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color .3s, background-color .3s, color .3s;
  transition: border-color .3s, background-color .3s, color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/ .el-submenu__title {
    font-size: 12pt;
    color: #303133;
    padding: 0 20px;
    cursor: pointer;
    -webkit-transition: border-color .3s,background-color .3s,color .3s;
    transition: border-color .3s,background-color .3s,color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}


.menu-div {
  margin-top: 18px;
  font-size: 12pt;
  font-weight: 300;
}
.header{
  overflow: hidden;
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 80px;
  min-width: 1220px;
}
.header_div {
  width: 100%;
  height: 80px;
  background-color: #fff;
  position: fixed;
  top: 0px;
  z-index: 1000;
  text-align: left;
  min-width: 1220px;
}

.header_left_div {
  float: left;
  width: 55%;
  height: 100%;
}

.header_right_div {
  float: left;
  width: 45%;
  height: 100%;
}

.header_font_border {
  height: 100%;
  width: 100px;
  color: black;
  text-align: center;
  padding-top: 30px;
  font-size: 18px
}

.right-icon-div {
  padding-top: 28px;
  font-size: 28px;
  color: #666666
}
</style>



// WEBPACK FOOTER //
// src/components/header_main.vue